import {LISTATTACHMENTS} from '../constants'
import axiosInstance from "../utils/axios.interceptor";

export const removeAttachment = (hashValue,agency) =>{
  return async (dispatch) => {
    let response = await axiosInstance({
      method: 'POST',
      url: '/removeAttachment',
      data: {"hashValue": hashValue}
    });
    //This is to trigger componentWillReceiveProps()
    response.data.timestamp = new Date().toLocaleString();

    let responseLIST = await axiosInstance({
      method: 'POST',
      url: '/listreferencesbyagency',
      data: {"agency": agency}
    });
    //This is to trigger componentWillReceiveProps()


    dispatch({type:LISTATTACHMENTS,payload:responseLIST.data});
  };
}

export const listAttachments = (agency) => {
  return async (dispatch) => {
    let response = await axiosInstance({
      method: 'POST',
      url: '/listreferencesbyagency',
      data: {"agency": agency}
    });
    //This is to trigger componentWillReceiveProps()
    response.data.timestamp = new Date().toLocaleString();
    dispatch({type:LISTATTACHMENTS,payload:response.data});
  };
};
